import axios from '../utils/request.js'

export function getResultBiddingMessage(pageNum,pageSize) {
    return axios({
        url: '/zy5/'+pageNum+'/'+pageSize,
        method: 'get',
        withCredentials: true
    })
}

// 查询中标结果
export function searchResultMessage(searchVo) {
    return axios({
        url: '/zy5/search',
        method: 'POST',
        data: searchVo,
        withCredentials: true
    })
}
